function createAction(name) {
  return `@@formSubmissionsTable/${name}`;
}
export const REQUEST_FORM_SUBMISSIONS_TABLE = createAction(`REQUEST_FORM_SUBMISSIONS_TABLE`);
export const REQUEST_FORM_SUBMISSIONS_TABLE_SUCCESS = createAction(`REQUEST_FORM_SUBMISSIONS_TABLE_SUCCESS`);
export const REQUEST_FORM_SUBMISSIONS_TABLE_FAIL = createAction(`REQUEST_FORM_SUBMISSIONS_TABLE_FAIL`);